module.exports={
  "Form": "Default-ChangeOrder",
  "Descriptors": {
    "Header.GI.ChangeOrderDate": {
      "Hash": "HeaderGIChangeOrderDate",
      "Name": "Change Order Date",
      "DataAddress": "Header.GI.ChangeOrderDate",
      "DataType": "Date",
      "PictForm": {
        "Row": "1",
        "Section": "Header",
        "Group": "General_Information",
        "InputExtra": ""
      },
      "Description": "The date associated with this change order"
    },
    "Header.ChangeOrderNumber_Raw": {
      "Hash": "HeaderChangeOrderNumber_Raw",
      "Name": "Change Order Sequence Number",
      "DataAddress": "Header.ChangeOrderNumber_Raw",
      "DataType": "Number",
      "PictForm": {
        "InputType": "Hidden",
        "Section": "Header",
        "Group": "General_Information"
      }
    },
    "Header.ChangeOrderNumber": {
      "Hash": "HeaderChangeOrderNumber",
      "Name": "Change Order Form #",
      "DataAddress": "Header.ChangeOrderNumber",
      "DataType": "String",
      "PictForm": {
        "Row": "1",
        "Section": "Header",
        "Group": "General_Information",
        "InputType": "ReadOnly",
        "InputExtra": ""
      },
      "Description": "The placement of this change order among all change orders"
    },
    "Header.GI.Notes": {
      "Hash": "HeaderGINotes",
      "Name": "Notes",
      "DataAddress": "Header.GI.Notes",
      "DataType": "String",
      "PictForm": {
        "InputType": "TextArea",
        "Row": "2",
        "Section": "Header",
        "Group": "General_Information",
        "Placeholder": "Enter a description, explanation, and estimated cost of proposed revision",
        "InputExtra": ""
      }
    },
    "Header.GI.DescriptionOfWork": {
      "Hash": "HeaderGIDescriptionOfWork",
      "Name": "Description of Work",
      "DataAddress": "Header.GI.DescriptionOfWork",
      "DataType": "String",
      "PictForm": {
        "InputType": "TextArea",
        "Row": "2",
        "Section": "Header",
        "Group": "General_Information",
        "Placeholder": "Enter a description of the work to be done",
        "InputExtra": ""
      }
    },
    "Summary.AdditionalDaysRequested": {
      "Hash": "SummaryAdditionalDaysRequested",
      "Name": "Additional Days",
      "DataAddress": "Summary.AdditionalDaysRequested",
      "DataType": "Number",
      "PictForm": {
        "Section": "Summary",
        "Group": "Days"
      }
    },
    "Summary.RevisionDate_ISODate": {
      "Hash": "SummaryRevisionDate_ISODate",
      "Name": "New Completion Date",
      "DataAddress": "Summary.RevisionDate_ISODate",
      "DataType": "Date",
      "PictForm": {
        "Section": "Summary",
        "Group": "Days"
      }
    },
    "Summary.CurrentTotalAmount": {
      "Hash": "SummaryCurrentTotalAmount",
      "Name": "Current Total Amount",
      "DataAddress": "Summary.CurrentTotalAmount",
      "DataType": "PreciseNumber",
      "PictForm": {
        "Section": "Summary",
        "Group": "Cost",
        "InputType": "ReadOnly",
        "Chips": {
          "Units": "$"
        },
        "UseInlineUnits": true,
        "Units": "$"
      }
    },
    "Summary.RevisionTotalAmount": {
      "Hash": "SummaryRevisionTotalAmount",
      "Name": "New Total Amount",
      "DataAddress": "Summary.RevisionTotalAmount",
      "DataType": "PreciseNumber",
      "PictForm": {
        "Section": "Summary",
        "Group": "Cost",
        "InputType": "ReadOnly",
        "Chips": {
          "Units": "$"
        },
        "UseInlineUnits": true,
        "Units": "$"
      }
    },
    "Summary.AdjustmentTotalAmount": {
      "Hash": "SummaryAdjustmentTotalAmount",
      "Name": "Adjustement Total Amount",
      "DataAddress": "Summary.AdjustmentTotalAmount",
      "DataType": "PreciseNumber",
      "PictForm": {
        "Section": "Summary",
        "Group": "Cost",
        "InputType": "ReadOnly",
        "Chips": {
          "Units": "$"
        },
        "UseInlineUnits": true,
        "Units": "$"
      }
    },
    "MediaDetailCards": {
      "Hash": "MediaMediaDetailCards",
      "Name": "Media",
      "DataAddress": "MediaDetailCards",
      "DataType": "String",
      "PictForm": {
        "InputType": "MediaDetailCards",
        "Section": "Media",
        "Group": "Observations",
        "InputExtra": "hideTitle: false, cardSize: flexible, sortOrder: desc, hideId: false, hideLabels: false"
      },
      "Description": ""
    },
    "MediaFileSelector": {
      "Hash": "RecordSetStandardFileSelector",
      "Name": "File Selector",
      "DataAddress": "MediaFileSelector",
      "DataType": "String",
      "PictForm": {
        "InputType": "FileSelector",
        "Section": "Media",
        "Group": "Files",
        "InputExtra": ""
      },
      "Description": "",
      "IsTabular": true
    }
  },
  "Sections": [
    {
      "Name": "Header",
      "Hash": "Header",
      "Solvers": [
        "HeaderChangeOrderNumber_Raw = getvalue(\"AppData.DocumentData.ReportData.SequenceNumber\")",
        "HeaderChangeOrderNumber = IF(HeaderChangeOrderNumber_Raw, \"<\", 10, CONCAT(\"CO-00\", HeaderChangeOrderNumber_Raw), IF(HeaderChangeOrderNumber_Raw, \"<\", 100, CONCAT(\"CO-0\", HeaderChangeOrderNumber_Raw), CONCAT(\"CO-\", HeaderChangeOrderNumber_Raw)))"
      ],
      "Groups": [
        {
          "Name": "General Information",
          "Hash": "General_Information",
          "Rows": [],
          "RecordSetSolvers": []
        }
      ]
    },
    {
      "Name": "New Items",
      "Hash": "NewItems",
      "Solvers": [],
      "Groups": [
        {
          "RecordSetSolvers": [
            "FormChangeOrderNumber = getGlobalFormData(\"HeaderChangeOrderNumber\")",
            "OneNewItemChangeOrderNumber = CONCAT(WHEN(FormChangeOrderNumber, FormChangeOrderNumber, \"CO-xxx\"), \"--\", OneNewItemNumber)",
            "OneNewFundingCategoryCode = WHEN(OneNewFundingCategoryCode, OneNewFundingCategoryCode, OneNewFundingCategoryRecordCode)",
            "OneNewAmount = ROUND(OneNewCostPerUnit * OneNewQuantity, 2)"
          ],
          "Layout": "RecordSet",
          "RecordSetAddress": "NewItem",
          "RecordManifest": "NewItemsManifest",
          "Rows": [],
          "Name": "Enter New Items",
          "Hash": "NewItemsTable"
        }
      ]
    },
    {
      "Name": "Existing Items",
      "Hash": "ExistingItems",
      "Solvers": [],
      "Groups": [
        {
          "RecordSetSolvers": [
            "OneExistingItemChangeOrderNumber = OneExistingLineItemRecordChangeOrderNumber",
            "OneUnits = WHEN(OneUnits, OneUnits, OneCurrentUnits)",
            "OneCurrentAmount = ROUND(OneCurrentCostPerUnit * OneCurrentQuantity, 2)",
            "OneNewCostPerUnit = IF(OneNewCostPerUnit, \"==\", 0, OneCurrentCostPerUnit, OneNewCostPerUnit)",
            "OneAdjustmentQuantity_LastSolve = IF(OneAdjustmentQuantity_LastSolve, \"==\", 0, OneAdjustmentQuantity, OneAdjustmentQuantity_LastSolve)",
            "OneNewQuantity_LastSolve = IF(OneNewQuantity_LastSolve, \"==\", 0, OneNewQuantity, OneNewQuantity_LastSolve)",
            "OneAdjustmentQuantity_Hidden = OneAdjustmentQuantity",
            "OneNewQuantity_Hidden = OneNewQuantity",
            "OneAdjustmentQuantity_Changed = 0",
            "OneNewQuantity_Changed = 0",
            "OneAdjustmentQuantity_Changed = IF(OneAdjustmentQuantity_Hidden, \"==\", OneAdjustmentQuantity_LastSolve, 0, 1)",
            "OneNewQuantity_Changed = IF(OneNewQuantity_Hidden, \"==\", OneNewQuantity_LastSolve, 0, 1)",
            "OneNewQuantity = IF(OneAdjustmentQuantity_Changed, \"==\", 1, OneCurrentQuantity + OneAdjustmentQuantity, OneNewQuantity)",
            "OneAdjustmentQuantity = IF(OneNewQuantity_Changed, \"==\", 1, OneNewQuantity - OneCurrentQuantity, OneAdjustmentQuantity)",
            "OneNewQuantity = IF(OneAdjustmentQuantity_Changed + OneNewQuantity_Changed, \"==\", 0, OneCurrentQuantity + OneAdjustmentQuantity, OneNewQuantity)",
            "OneAdjustmentQuantity_LastSolve = OneAdjustmentQuantity",
            "OneNewQuantity_LastSolve = OneNewQuantity",
            "OneNewAmount = ROUND(OneNewCostPerUnit * OneNewQuantity, 2)"
          ],
          "Layout": "RecordSet",
          "RecordSetAddress": "CurrentItem",
          "RecordManifest": "ExistingItemsManifest",
          "Rows": [],
          "Name": "Enter the Items to modify",
          "Hash": "ExistingItemsTable"
        }
      ]
    },
    {
      "Name": "Summary",
      "Hash": "Summary",
      "Solvers": [
        "SummaryCurrentTotalAmount = SUM(FLATTEN(CurrentItem[].CurrentAmount))",
        "SummaryRevisionTotalAmount = SUM(FLATTEN(NewItem[].NewAmount)) + SUM(FLATTEN(CurrentItem[].NewAmount))",
        "SummaryAdjustmentTotalAmount = SummaryRevisionTotalAmount - SummaryCurrentTotalAmount"
      ],
      "Groups": [
        {
          "Name": "Days",
          "Hash": "Days",
          "Rows": [],
          "RecordSetSolvers": []
        },
        {
          "Name": "Cost",
          "Hash": "Cost",
          "Rows": [],
          "RecordSetSolvers": []
        }
      ]
    },
    {
      "Name": "Media",
      "Hash": "Media",
      "Solvers": [],
      "Groups": [
        {
          "Name": "Observations",
          "Hash": "Observations",
          "Rows": [],
          "RecordSetSolvers": [],
          "ShowTitle": false
        },
        {
          "Name": "Files",
          "Hash": "Files",
          "Rows": [],
          "RecordSetSolvers": [],
          "ShowTitle": false
        }
      ]
    }
  ],
  "ReferenceManifests": {
    "ExistingItemsManifest": {
      "Scope": "ExistingItemsManifest",
      "Descriptors": {
        "LineItem_IDLineItem": {
          "Hash": "OneExistingItem",
          "DataAddress": "LineItem_IDLineItem",
          "Name": "Item",
          "DataType": "Number",
          "PictForm": {
            "Row": "1",
            "InputType": "EntitySelector",
            "Entity": "LineItem",
            "EntityTag": "ItemNumber",
            "InputExtra": "",
            "Placeholder": "select an item to modify...",
            "Providers": [
              "Pict-Input-Select",
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAllInputs": true,
              "PostSolvers": [
                "runSolvers()",
                "refreshtabularsection(\"ExistingItems\",\"ExistingItemsTable\")"
              ],
              "EntitiesBundle": [
                {
                  "Entity": "LineItem",
                  "Filter": "FBV~IDLineItem~EQ~{~D:Record.Value~}",
                  "Destination": "SelectedLineItem",
                  "SingleRecord": true
                }
              ]
            }
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record": {
          "Hash": "OneExistingLineItemRecord",
          "DataAddress": "LineItem_IDLineItem__Record",
          "Name": "LineItemRecord",
          "DataType": "Object",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.Name": {
          "Hash": "OneExistingLineItemRecordName",
          "DataAddress": "LineItem_IDLineItem__Record.Name",
          "Name": "LineItemRecordName",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.Units": {
          "Hash": "OneExistingLineItemRecordUnits",
          "DataAddress": "LineItem_IDLineItem__Record.Units",
          "Name": "LineItemRecordUnit",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.ExpectedQuantity": {
          "Hash": "OneExistingLineItemRecordExpectedQuantity",
          "DataAddress": "LineItem_IDLineItem__Record.ExpectedQuantity",
          "Name": "LineItemRecordExpectedQuantity",
          "DataType": "PreciseNumber",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.CostPerUnit": {
          "Hash": "OneExistingLineItemRecordCostPerUnit",
          "DataAddress": "LineItem_IDLineItem__Record.CostPerUnit",
          "Name": "LineItemRecordCostPerUnit",
          "DataType": "PreciseNumber",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.ChangeOrderNumber": {
          "Hash": "OneExistingLineItemRecordChangeOrderNumber",
          "DataAddress": "LineItem_IDLineItem__Record.ChangeOrderNumber",
          "Name": "LineItemRecordChangeOrderNumber",
          "DataType": "PreciseNumber",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_Name": {
          "Hash": "OneExistingItemName",
          "DataAddress": "LineItem_Name",
          "Name": "Name",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.Name",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "ChangeOrderNumber": {
          "Hash": "OneExistingItemChangeOrderNumber",
          "DataAddress": "ChangeOrderNumber",
          "Name": "Change Order #",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.ChangeOrderNumber",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentQuantity": {
          "Hash": "OneCurrentQuantity",
          "DataAddress": "CurrentQuantity",
          "Name": "Current Quantity",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.ExpectedQuantity",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentUnits": {
          "Hash": "OneCurrentUnits",
          "DataAddress": "CurrentUnits",
          "Name": "Current Units",
          "DataType": "String",
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.Units",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentCostPerUnit": {
          "Hash": "OneCurrentCostPerUnit",
          "DataAddress": "CurrentCostPerUnit",
          "Name": "Current Cost Per Unit",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.CostPerUnit",
              "PostSolvers": [
                "runSolvers()",
                "refreshtabularsection(\"ExistingItems\",\"ExistingItemsTable\")"
              ],
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentAmount": {
          "Hash": "OneCurrentAmount",
          "DataAddress": "CurrentAmount",
          "Name": "Current Amount",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        },
        "AdjustmentQuantity": {
          "Hash": "OneAdjustmentQuantity",
          "DataAddress": "AdjustmentQuantity",
          "Name": "Adjustment Quantity",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "3",
            "Width": "3"
          },
          "Description": "Enter a value to add to or subtract from the current quantity. New Quantity will update automatically.",
          "IsTabular": true
        },
        "AdjustmentQuantity_LastSolve": {
          "Hash": "OneAdjustmentQuantity_LastSolve",
          "DataAddress": "AdjustmentQuantity_LastSolve",
          "Name": "Adjustment Quantity Last Solve",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "AdjustmentQuantity_Hidden": {
          "Hash": "OneAdjustmentQuantity_Hidden",
          "DataAddress": "AdjustmentQuantity_Hidden",
          "Name": "Adjustment Quantity Hidden",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "AdjustmentQuantity_Changed": {
          "Hash": "OneAdjustmentQuantity_Changed",
          "DataAddress": "AdjustmentQuantity_Changed",
          "Name": "Adjustment Quantity Changed",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "NewQuantity": {
          "Hash": "OneNewQuantity",
          "DataAddress": "NewQuantity",
          "Name": "New Quantity",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "4"
          },
          "Description": "Enter the final quantity directly. Adjustment Quantity will update automatically.",
          "IsTabular": true
        },
        "NewQuantity_LastSolve": {
          "Hash": "OneNewQuantity_LastSolve",
          "DataAddress": "NewQuantity_LastSolve",
          "Name": "New Quantity Last Solve",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "NewQuantity_Hidden": {
          "Hash": "OneNewQuantity_Hidden",
          "DataAddress": "NewQuantity_Hidden",
          "Name": "New Quantity Hidden",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "NewQuantity_Changed": {
          "Hash": "OneNewQuantity_Changed",
          "DataAddress": "NewQuantity_Changed",
          "Name": "New Quantity Changed",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "Units": {
          "Hash": "OneUnits",
          "DataAddress": "Units",
          "Name": "New Units",
          "DataType": "String",
          "PictForm": {
            "Row": "4",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.Units",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "NewCostPerUnit": {
          "Hash": "OneNewCostPerUnit",
          "DataAddress": "NewCostPerUnit",
          "Name": "New Cost Per Unit",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "4",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.CostPerUnit",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "NewAmount": {
          "Hash": "OneNewAmount",
          "DataAddress": "NewAmount",
          "Name": "New Amount",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "4",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        }
      }
    },
    "NewItemsManifest": {
      "Scope": "NewItemsManifest",
      "Descriptors": {
        "LineItem_IDLineItem": {
          "Hash": "OneNewItem",
          "DataAddress": "LineItem_IDLineItem",
          "Name": "Item",
          "DataType": "Number",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "ChangeOrderNumber": {
          "Hash": "OneNewItemChangeOrderNumber",
          "DataAddress": "ChangeOrderNumber",
          "Name": "Change Order #",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "PayItem_IDPayItem": {
          "Hash": "OneNewPayItem",
          "DataAddress": "PayItem_IDPayItem",
          "Name": "Pay Item",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "Row": "1",
            "Width": "5",
            "InputType": "EntitySelector",
            "Entity": "PayItem",
            "EntityTag": "ItemCode",
            "InputExtra": "",
            "Placeholder": "link a master pay item...",
            "Providers": [
              "Pict-Input-Select"
            ]
          },
          "IsTabular": true
        },
        "ItemNumber": {
          "Hash": "OneNewItemNumber",
          "DataAddress": "ItemNumber",
          "Name": "Item Number",
          "DataType": "String",
          "PictForm": {
            "Row": "2",
            "Width": "2"
          },
          "IsTabular": true
        },
        "LineItem_Name": {
          "Hash": "OneNewItemName",
          "DataAddress": "LineItem_Name",
          "Name": "Item Name",
          "DataType": "String",
          "PictForm": {
            "Row": "2",
            "Width": "5"
          },
          "IsTabular": true
        },
        "NewQuantity": {
          "Hash": "OneNewQuantity",
          "DataAddress": "NewQuantity",
          "Name": "New Quantity",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "3"
          },
          "IsTabular": true
        },
        "Units": {
          "Hash": "OneUnits",
          "DataAddress": "Units",
          "Name": "Units",
          "DataType": "String",
          "PictForm": {
            "Row": "3"
          },
          "IsTabular": true
        },
        "NewCostPerUnit": {
          "Hash": "OneNewCostPerUnit",
          "DataAddress": "NewCostPerUnit",
          "Name": "New Cost Per Unit",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "3",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        },
        "NewAmount": {
          "Hash": "OneNewAmount",
          "DataAddress": "NewAmount",
          "Name": "New Amount",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "3",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        },
        "FundingCategory_IDFundingCategory": {
          "Hash": "OneNewFundingCategory",
          "DataAddress": "FundingCategory_IDFundingCategory",
          "Name": "Funding Category",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "Row": "2",
            "Width": "5",
            "InputType": "EntitySelector",
            "Entity": "FundingCategory",
            "EntityTag": "Code",
            "InputExtra": "",
            "Placeholder": "select a funding category...",
            "Providers": [
              "Pict-Input-Select",
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneNewFundingCategoryTrigger",
              "TriggerAllInputs": true,
              "EntitiesBundle": [
                {
                  "Entity": "FundingCategory",
                  "Filter": "FBV~IDFundingCategory~EQ~{~D:Record.Value~}",
                  "Destination": "SelectedFundingCategory",
                  "SingleRecord": true
                }
              ]
            }
          },
          "IsTabular": true
        },
        "FundingCategory_Code": {
          "Hash": "OneNewFundingCategoryCode",
          "DataAddress": "FundingCategory_Code",
          "Name": "Category Code",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneNewFundingCategoryTrigger",
              "TriggerAddress": "SelectedFundingCategory.Code",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        }
      }
    }
  },
  "FormName": "Default Change Order"
}
